<h1 mat-dialog-title>Enter Comment</h1>
<div mat-dialog-content>
  <textarea [(ngModel)]="comment" placeholder="Enter your comment" rows="4" cols="50"></textarea>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="comment">Submit</button>
</div>